<template>
    <alert-container-styled>
        <alert-banner
            v-for="(item, i) in alerts"
            :key="item.uid"
            :uid="item.uid"
            :icon="item.icon"
            :message="item.message"
            :type="item.type"
            :index="i"
            @alert-close="removeHandler"
        />
    </alert-container-styled>
</template>
<script>
import styled from "vue-styled-components";
import AlertBanner from "./AlertBanner";
import { state, mutations } from "./store";

const AlertContainerStyled = styled("div", { position: String })`
    position: fixed;
    top: 14px;
    z-index: 10;
    left: 0;
    right: 0;
`;

export default {
    name: "StAlert",
    data: () => ({
        alerts: state.alerts
    }),
    methods: {
        removeHandler(uid) {
            mutations.removeAlert(uid);
        }
    },
    components: {
        AlertContainerStyled,
        AlertBanner
    }
};
</script>
